<div class="auth-container">
  <div class="row">
    <div class="login-container">
      @if (showLoader) {
        <div class="row mt-4">
          <div class="col-12 d-flex justify-content-center">
            <mat-spinner [diameter]="24"></mat-spinner>
            <span class="mx-2">Processing...</span>
          </div>
        </div>
      }
      @if (isDirect === 'true' && !showLoader) {
        <div
          class="login-box text-center"
          >
          <div class="title">Thank You</div>
          <p>
            You have been successfully removed from this subscriber list
            and won't receive any further emails from us.
          </p>
        </div>
      }
      @if (isDirect !== 'true' && !showLoader) {
        <div
          class="login-box text-center"
          >
          <div class="title">Confirm unsubscription</div>
          <section>
            <label class="mb-1 mt-3" for="email-or-phone"
              >Please enter 'unsubscribe' to below textbox</label
              >
              <input
                class="form-control dd-privacy-allow lower-case mb-1"
                id="unsubscribe-input"
                name="email-or-phone"
                autofocus
                (input)="checkValue($event)"
                />
            </section>
            <section class="text-center">
              <button
                class="btn btn-normal btn-pink mt-3 btn-pink-filled submit-btn"
                id="unsubscribe-button"
                type="submit"
                [disabled]="!isSubmit"
                (click)="unsubscribe()"
                >
                Submit
              </button>
            </section>
          </div>
        }
      </div>
    </div>
  </div>
